import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15b1b20a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=15b1b20a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b1b20a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b1b20a')) {
      api.createRecord('15b1b20a', component.options)
    } else {
      api.reload('15b1b20a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15b1b20a&scoped=true", function () {
      api.rerender('15b1b20a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/Sharelist/index.vue"
export default component.exports